/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProgressBar/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ProgressBar({
  children,
  viewPath = "/DesignSystem/ProgressBar",
  marginTop = 0,
  value = 0
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
  return (<React.Fragment
>
<div
  data-testid="ProgressBar.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1L134q': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--bblr-2-Z1L134q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-Z1L134q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-4-Z1L134q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-Z1L134q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-6-Z1L134q': dtColorsGreen700}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="ProgressBar.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bc-7-Z1L134q': dtColorsGreen700,'--bblr-2-Z1L134q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-Z1L134q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-4-Z1L134q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-Z1L134q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--w-8-Z1L134q': value ? typeof value === 'number' ? `${value}px` : value : "0px"}}
 className={`views-block ${styles.Horizontal1}`}
/>
</div>
{children}
</React.Fragment>)
}